import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalCloseButton,
    Button,
    FormControl,
    FormLabel,
    Textarea,
    VStack,
    HStack,
    Text,
    useToast
} from "@chakra-ui/react";
import CommonService from '../../services/CommonService';

import { use, useEffect, useState } from "react";
import RatingSelector from "../../components/RatingSelector";

const DriverRatingModal = ({
    isOpen,
    onClose,
    DriveNo,
    PassengerID,
    DriverID,
}) => {
    const toast = useToast();
    const [driving, setDriving] = useState(5);
    const [vehicle, setVehicle] = useState(5);
    const [driver, setDriver] = useState(5);
    const [remark, setRemark] = useState("");
    const [loading, setLoading] = useState(false)

    const handleSubmit = async () => {
        setLoading(true)
        const payload = {
            DriveNo,
            Driving: driving,
            Vehicle: vehicle,
            Driver: driving,
            Passenger: 0,
            Rating_By_UId: PassengerID,
            Rating_For_UId: DriverID,
            Remarks: remark || ""
        };

        try {
            const res = await CommonService.saveDriverRating(payload)
            if (res.statusCode === 200) {
                toast({
                    title: 'Rating Submitted Successfully',
                    status: 'success',
                    duration: 5000, // 10 seconds
                    isClosable: true,
                    position: 'top-right'
                });
                onClose()
            }
        } catch (error) {
            console.error("Error fetching users:", error);
            return false;
        }
        finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        setDriving(5);
        setVehicle(5)
        setDriver(5)
        setRemark("")
    }, [isOpen])

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />

            <ModalContent>
                <ModalHeader>Rate Your Ride</ModalHeader>

                <ModalCloseButton />

                <ModalBody>
                    <VStack spacing={5} align="stretch">

                        <RatingSelector
                            label="Driving Rating"
                            value={driving}
                            onChange={setDriving}
                        />

                        <RatingSelector
                            label="Vehicle Rating"
                            value={vehicle}
                            onChange={setVehicle}
                        />

                        <RatingSelector
                            label="Driver Rating"
                            value={driver}
                            onChange={setDriver}
                        />

                        <FormControl>
                            <FormLabel>Remark</FormLabel>

                            <Textarea
                                value={remark}
                                onChange={(e) => setRemark(e.target.value)}
                                placeholder="Enter Remark"
                            />
                        </FormControl>

                    </VStack>
                </ModalBody>

                <ModalFooter>
                    <Button mr={3} onClick={onClose}>
                        Close
                    </Button>

                    <Button
                        colorScheme="teal"
                        onClick={handleSubmit}
                        disabled={loading}
                        type="button"
                    >
                        {loading ? "Submitting..." : "Submit"}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default DriverRatingModal;